import { Reveal, MaskedLines } from "@/components/motion";

export default function PageHero({ eyebrow, title, subtitle, children }) {
  return (
    <section data-testid="page-hero" className="relative overflow-hidden bg-[#FEF7F2] pt-24 pb-6 md:pt-28 md:pb-10">
      <div className="pointer-events-none absolute -top-20 right-0 h-80 w-80 rounded-full bg-[#2FA86A]/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -left-16 h-80 w-80 rounded-full bg-[#142A5E]/5 blur-3xl" />
      <div className="nc-container relative max-w-3xl">
        <Reveal>
          <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.2em] text-[#2FA86A]">
            <span className="h-px w-8 bg-[#2FA86A]" />
            {eyebrow}
          </span>
        </Reveal>
        <h1 className="mt-5 font-display text-3xl sm:text-4xl lg:text-[3.1rem] font-extrabold tracking-tight leading-[1.1] text-[#1B1B1B]">
          {Array.isArray(title) ? <MaskedLines lines={title} /> : title}
        </h1>
        {subtitle && (
          <Reveal delay={0.2}>
            <p className="mt-6 text-lg leading-relaxed text-[#1B1B1B]/60">{subtitle}</p>
          </Reveal>
        )}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </section>
  );
}
